// Card页面相关的类型定义和枚举

/**
 * 卡片类型
 * 电子卡和实体卡
 */
export const enum CardType {
  ElectronicCard = 'electronic',
  PhysicalCard = 'physical'
}